import ViewLink from './viewLink.vue'
import PdfLink from './pdfLink.vue'
import DateSelector from './dateSelector/index.vue'
import UserModifyPwd from './systemManage/user/modifyPwd.vue'
import commUploader from '@/components/upload/index.vue'
import AdvancedSearch from './pageLayout/advanceSearch.vue'
import DataBoardBox from './pageLayout/boradBox.vue'
import AreaSelector from './areaSelector/index.vue'
export default {
    install: (Vue: any) => {
        Vue.component('commUploader', commUploader)
        Vue.component('viewLink', ViewLink)
        Vue.component('pdfLink', PdfLink)
        Vue.component('btnAdvancedSearch', AdvancedSearch)
        Vue.component('dateSelector', DateSelector)
        Vue.component('userModifyPwd', UserModifyPwd)
        Vue.component('boradBox', DataBoardBox)
        Vue.component('areaSelector', AreaSelector)
    }
}
